import styles from "./ui-utils.module.scss";
import widgetStyles from "./ui-utils-widget.module.scss";
export default { ...styles, ...widgetStyles };
